import { styled } from "styled-components";
import { AiOutlineClose } from "react-icons/ai";
import { BsGithub } from "react-icons/bs";
import { ProjectInfo } from "../ProjectInfo";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    position: fixed;
    width: 50%;
    opacity: ${({ isActive }) => isActive ? 1 : 0};
    pointer-events: ${({ isActive }) => isActive ? "all" : "none"};
    height: 80%;
    background-color: white;
    z-index: 10;
    top: 50%;
    left: 50%;
    transition: all 200ms;
    transform: ${({ isActive }) => isActive ? "scale(1)" : "scale(.8)"} translate(-50%, -50%);

    border-radius: 25px;
    box-shadow: 0 0 10px 10px #ebebeb;

    @media (max-width: 1000px) {
        width: 80%;
    }

    @media (max-width: 600px) {
        width: 100%;
        height: 100%;
        border-radius: 0;
    }
`;

const Banner = styled.div`
    width: 100%;
    height: 150px;
    background-color: ${({ color }) => color};

    border-radius: ${({ theme }) => theme.borderRadius} ${({ theme }) => theme.borderRadius} 0 0;
    
    @media (max-width: 600px) {
        border-radius: 0;
    }
`;

const Title = styled.h1``;

const CloseButton = styled.button`
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 2rem;
    background-color: ${({ color }) => color};
    border: none;
    cursor: pointer;
`;

const Content = styled.div`
    flex: 1;
    padding: 2rem;
    position: relative;
`;

const Summary = styled.p`
    margin-bottom: 10px;
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    margin: 0 auto;
    background-color: #00000019;
    margin-top: 15px;
`;

const Resume = styled.p`
    padding: 15px 0;
`;

const GoToCodeButton = styled.button`
    position: absolute;
    bottom: 2rem;
    right: 2rem;
    background-color: #0d1117;
    border: none;
    padding: 6px 10px;
    border-radius: 10px;
    cursor: pointer;
    transition: all 150ms;
    font-size: 1.3rem;
    
    &:hover {
        box-shadow: 0px 0px 3px 4px #0d111733;
    }

    a {
        display: flex;
        flex-direction: row;
        color: white;
        align-items: center;
        gap: 5px;
    }
`;

export function ProjectModal({ name, color, summary, type, technologies, isModalOpen, setIsModalOpen, githubUrl, description }) {
    return (
        <Container isActive={isModalOpen} color={color}>
            <Banner color={color} />
            <CloseButton onClick={() => setIsModalOpen(false)} color={color}>
                <AiOutlineClose fill="#fff" />
            </CloseButton>
            <Content>
                <Title>
                    {name}
                </Title>
                <Summary>
                    {summary}
                </Summary>
                <ProjectInfo technologies={technologies} type={type} />
                <Divider />
                <Resume dangerouslySetInnerHTML={{ 
                    __html: description ?? "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Impedit modi minus sunt, amet tenetur consequatur dolor dignissimos perspiciatis debitis, quasi sapiente ut, quia maiores minima quis adipisci accusantium perferendis consequuntur!"
                }}>
                </Resume>
                <GoToCodeButton>
                    <a href={githubUrl} target="_blank" rel="noreferrer noopener">
                        <BsGithub fill="#fff" />
                        explorar o projeto
                    </a>
                </GoToCodeButton>
            </Content>
        </Container>
    )
}